// extracted by mini-css-extract-plugin
export default {"task-detail-title":"index_task-detail-title__b6GvD","task-detail-content":"index_task-detail-content__sLeUJ","task-detail-modal":"index_task-detail-modal__+67IQ"};